import { styled, thd, down, css } from '@smooth-ui/core-sc';

export default styled.nav`
  transition: all 0.3s ease 0s;

  ${down(
    'lg',
    css`
      background-color: ${thd('customMenuBackground', '#fff')};
      height: 100vh;
      overflow-y: scroll;
      position: fixed;
      right: ${props => (props.openMobileMenu ? '0' : '-100%')};
      top: 0;
      visibility: ${props => (props.openMobileMenu ? 'visible' : 'hidden')};
      width: 100%;
      z-index: 100;
      li {
        border-bottom: 1px white solid;
      }
    `
  )};
`;
